import { useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "store/actions";

export const useReduxLookups = (isVendor) => {
  const dispatch = useDispatch();

  // Select lookups state from Redux store
  const countries = useSelector((state) => state.countries || []);
  const cities = useSelector((state) => state.cities || []);
  const domains = useSelector((state) => state.domains || []);
  const subDomains = useSelector((state) => state.subDomains || []);
  const languages = useSelector((state) => state.languages || []);
  const nationalities = useSelector((state) => state.nationalities || []);
  const services = useSelector((state) => state.services || []);
  const timezones = useSelector((state) => state.timezones || []);
  const currencies = useSelector((state) => state.currencies || []);
  const poStatuses = useSelector((state) => state.poStatuses || []);

  // Action dispatchers
  const getCountries = () => {
    dispatch(actions.fetchCountries());
  };

  const getCities = (countryId) => {
    dispatch(actions.fetchCities(countryId));
  };

  const getDomains = () => {
    dispatch(actions.fetchDomains());
  };

  const getSubDomains = (domainIds) => {
    dispatch(actions.fetchSubDomains(domainIds));
  };

  const getLanguages = () => {
    dispatch(actions.fetchLanguages());
  };

  const getNationalities = () => {
    dispatch(actions.fetchNationalities());
  };

  const getServices = () => {
    dispatch(actions.fetchServices());
  };

  const getTimeZones = (countryId) => {
    dispatch(actions.fetchTimezones(countryId));
  };

  const getCurrencies = () => {
    dispatch(actions.fetchCurrencies());
  };

  const resetLookups = () => {
    dispatch(actions.resetLookups());
  };

  const dataToBeLoaded = useMemo(
    () =>
      countries.length > 0 &&
      domains.length > 0 &&
      languages.length > 0 &&
      nationalities.length > 0 &&
      services.length > 0,
    [countries, domains, languages, nationalities, services]
  );

  useEffect(() => {
    let flag = false;
    if (!dataToBeLoaded && !flag) {
      flag = true;
      getCountries();
      getDomains();
      getLanguages();
      getNationalities();
      getServices();
    }
  }, [dataToBeLoaded]);

  return {
    countries,
    cities,
    domains,
    subDomains,
    languages,
    nationalities,
    services: services.filter((service) => {
      if (isVendor) {
        // For vendors, return services where notForVendor is false
        return !service.notForVendor;
      } else {
        // For agencies, return services where notForAgency is false
        return !service.notForAgency;
      }
    }),
    timezones,
    getCountries,
    getCities,
    getDomains,
    getLanguages,
    getNationalities,
    getServices,
    getTimeZones,
    currencies,
    resetLookups,
    dataToBeLoaded,
    getSubDomains,
    getCurrencies,
    poStatuses,
  };
};
